import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseService} from './base.service';
import {Observable} from 'rxjs';
import {AlertService} from './alert.service';
import {GlobalService} from './global.service';
import {AppUrl} from '../constants/app-url';

@Injectable({
    providedIn: 'root'
})
export class PopularCourseSubjectSyllabusService extends BaseService {
    constructor(public http: HttpClient,
                public alertService: AlertService,
                public globalService: GlobalService) {
        super(http, alertService, globalService);
    }

    detail(id): Observable<any> {
        return this.getRequest(AppUrl.POPULAR_COURSE_SUBJECT_SYLLABUS(id));
    }

    create(id, data): Observable<any> {
        return this.postRequest(AppUrl.POPULAR_COURSE_SUBJECT_SYLLABUS(id), data);
    }

    update(id, data): Observable<any> {
        return this.putRequest(AppUrl.POPULAR_COURSE_SUBJECT_SYLLABUS(id), data);
    }

    createByAdmin(id, data): Observable<any> {
        return this.postRequestWithoutDataDeletion(AppUrl.POPULAR_COURSE_SUBJECT_SYLLABUS(id), data);
    }

    detailByAdmin(id): Observable<any> {
        return this.getRequestWithoutErrorMessage(AppUrl.POPULAR_COURSE_SUBJECT_SYLLABUS(id));
    }

    updateByAdmin(id, data): Observable<any> {
        return this.putRequestWithoutDataDeletion(AppUrl.POPULAR_COURSE_SUBJECT_SYLLABUS(id), data);
    }
}
